import React from 'react';
import { Link } from 'react-router-dom';
import { IoIosArrowForward } from 'react-icons/io';
import './FeaturedPosts.css';
import LogoAlt from '../../../assets/logoAlt.svg';
import { FeaturedSkeleton } from '../BlogSkeleton';

const FeaturedPosts = ({ posts = [], loading = false }) => {
  return (
    <section className="featured-posts">
      <div className="page-container">
        <h2>Featured Posts</h2>
        {loading ? (
          <FeaturedSkeleton />
        ) : posts.length ? (
          <div className="featured-posts-grid">
            {posts.map((post) => (
              <article key={post.id} className="featured-card">
                <div className="featured-card-meta">
                  <span className="featured-date">{post.date}</span>
                  <span className="featured-category">
                    <span className="category-dot" aria-hidden="true" />
                    {post.category}
                  </span>
                </div>
                <Link to={`/blog/${post.slug}`} className="featured-card-image">
                  {post.image ? <img src={post.image} alt="" /> : null}
                </Link>
                <Link to={`/blog/${post.slug}`} className="featured-card-title">
                  {post.title}
                </Link>
                <div className="featured-card-footer">
                  <div className="featured-author">
                    <img src={LogoAlt} alt="" className="featured-avatar" />
                    <span>{post.author}</span>
                  </div>
                  <Link
                    to={`/blog/${post.slug}`}
                    className="featured-arrow"
                    aria-label={`Read ${post.title}`}
                  >
                    <IoIosArrowForward />
                  </Link>
                </div>
              </article>
            ))}
          </div>
        ) : (
          <p className="blog-empty-state">No featured posts yet.</p>
        )}
      </div>
    </section>
  );
};

export default FeaturedPosts;
